const EXCELLENT = "Excellent"
const GOOD = "Good"
const MIDDLE = "Middle"
const BAD = "Passable"

const BON = "Bon"
const MOYEN = "Moyen"

const CORRESP = [
	{ key: EXCELLENT, value: 4 },
	{ key: GOOD, value: 3 },
	{ key: BON, value: 3 },
	{ key: MIDDLE, value: 2 },
	{ key: MOYEN, value: 2 },
	{ key: BAD, value: 1 }
]

export default (product) => {
	const corresp = CORRESP.find(c => c.key == product.copy)

	if (corresp) {
		return corresp.value
	}

	return null
}
